/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Notice_RankingInputs */

const en_seller_notice_ranking = /** @type {(inputs: Seller_Notice_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How results are ordered`)
};

const pl_seller_notice_ranking = /** @type {(inputs: Seller_Notice_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak ustalamy kolejność wyników`)
};

/**
* | output |
* | --- |
* | "How results are ordered" |
*
* @param {Seller_Notice_RankingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_ranking = /** @type {((inputs?: Seller_Notice_RankingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_RankingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_ranking(inputs)
	return en_seller_notice_ranking(inputs)
});